import NotAuthorizedContent from "../components/NotAuthorizedContent/NotAuthorizedContent"

const NotAuthorized = () => <NotAuthorizedContent />

export default NotAuthorized
